module.exports = __webpack_public_path__ + "assets/img/ic-google.bab02476.svg";